import { useState, useMemo } from "react";
import { Button, Modal, Select, message } from "antd";
import { finalizeDpSoaTable } from "src/DigitalProtocolModule/utils/ajax-proxy";
import styles from "./index.module.scss";
import "./index.scss";

interface FinalizeSoaModalProps {
  visible: boolean;
  trialUuid: string;
  soaList: Digital_Protocol_SoA.LandingInfoType[];
  handleCancel: () => void;
  afterConfirm: () => void;
}

export function FinalizeSoaModal({
  visible,
  trialUuid,
  soaList,
  handleCancel,
  afterConfirm,
}: FinalizeSoaModalProps) {
  const [isSaving, setIsSaving] = useState(false);
  const [selectedTableId, setSelectedTableId] = useState<number[]>([]);

  const filteredSoaOption = useMemo(() => {
    return soaList
      .filter((item) => item.soa_status.toLowerCase().includes("progress"))
      .map((item) => ({
        value: item.table_id,
        label: item.table_name,
      }));
  }, [soaList]);

  const handleChange = (val) => {
    setSelectedTableId(val);
  };

  const doFinalize = async () => {
    if (selectedTableId?.length === 0) {
      return;
    }

    setIsSaving(true);
    try {
      const res = await finalizeDpSoaTable({
        trial_uuid: trialUuid,
        table_id: selectedTableId,
      });
      setIsSaving(false);
      if (res.table_id) {
        message.success("SoA table finalized successfully.");
        afterConfirm();
      } else {
        message.success("SoA table finalized failed.");
      }
    } catch (error) {
      setIsSaving(false);
      message.success("SoA table finalized failed.");
    }
  };

  return (
    <Modal
      visible={visible}
      title="Finalize Schedule of Activities"
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          style={{
            backgroundColor: "#ca4a04",
            color: "#fff",
            borderColor: "#ca4a04",
          }}
          onClick={doFinalize}
          disabled={selectedTableId?.length === 0}
          loading={isSaving}
        >
          Finalize SOA
        </Button>,
      ]}
      wrapClassName="finalize-soa-modal-root"
    >
      <div className={styles.desc}>
        Please select the Schedule of Activities you would like to Finalize.
      </div>
      <div className={styles.desc}>
        Please note that finalizing a Schedule of Activities means you have
        completed all components of the SOA.
      </div>

      <label className={styles.label}>
        SOAs in Progress
        <span className={styles.required}>*</span>
      </label>

      <div>
        <Select
          mode="multiple"
          placeholder="Select an SOA"
          value={selectedTableId}
          onChange={handleChange}
          options={filteredSoaOption}
          style={{ width: "100%" }}
        />
      </div>
    </Modal>
  );
}
